import { useMemo } from 'react';

import leapifyLogo from 'assets/images/Leapify-Logo.svg';
import { type FormikHelpers } from 'formik';
import { Formik } from 'formik';
import { TermsPolicy } from 'pages/public/components/common';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { cn } from 'utils/helpers';

import SetInvitePasswordForm from '../../../public/forms/SetInvitePasswordForm';
import {
  SET_INVITE_PASSWORD_FORM,
  SET_INVITE_PASSWORD_SCHEMA,
} from '../../../public/forms/schema';
import { useChangePassword } from '../../hooks';
import PublicWrapper from '../PublicWrapper';

const INITIAL_VALUE = {
  password: '',
  passwordConfirmation: '',
};

const SetPassword = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { mutate: setPassword } = useChangePassword();

  const otp = useMemo(() => params.get('otp'), [params]);
  const referenceId = useMemo(() => params.get('referenceId'), [params]);

  const onSubmit = (
    values: SET_INVITE_PASSWORD_FORM,
    { setSubmitting }: FormikHelpers<SET_INVITE_PASSWORD_FORM>,
  ) => {
    setPassword(
      {
        ...values,
        otp,
        referenceId,
        type: 'ACCOUNT_INVITE',
      },
      {
        onSuccess: () => {
          navigate('/invite/start-now');
        },
        onSettled: () => {
          setSubmitting(false);
        },
      },
    );
  };

  return (
    <PublicWrapper
      className={cn('h-screen', 'flex flex-col items-center justify-center')}
    >
      <div
        className={cn(
          'w-[500px] bg-fill-tertiary p-10',
          'mt-24',
          'rounded-[6px] shadow-leapify-sm',
        )}
      >
        <img
          alt="Leapify Logo"
          className="mx-auto mb-[60px] block w-[170px]"
          src={leapifyLogo}
        />
        <h3 className="text-center text-xl font-semibold">Set password</h3>
        <Formik
          initialValues={INITIAL_VALUE}
          validationSchema={SET_INVITE_PASSWORD_SCHEMA}
          onSubmit={onSubmit}
        >
          {() => <SetInvitePasswordForm />}
        </Formik>
      </div>
      <div className="h-10" />
      <TermsPolicy />
    </PublicWrapper>
  );
};

export default SetPassword;
